import {
  Box,
  Collapse,
  Alert,
  AlertTitle,
  Typography,
  Button,
} from "@mui/material";
import { useSnackpack } from "components/context/SnackpackContextProvider";
import { Handle } from "components/editor/DocumentEditor";

// Version Error Alert Component
interface VersionErrorAlertProps {
  absolutePosition?: boolean;
  show: boolean;
  editorRef: React.RefObject<Handle>;
}

export default ({
  absolutePosition = true,
  show,
  editorRef,
}: VersionErrorAlertProps) => {
  const { pushSnack } = useSnackpack();

  // Handle copying current content and refreshing page
  const handleCopyAndRefresh = async () => {
    // Get current content from editor
    const editorContent = editorRef.current?.getContent();
    await navigator.clipboard.writeText(editorContent?.html || "");
    pushSnack({
      message: "Current content copied to clipboard",
      alertSeverity: "success",
      key: "content-copied",
    });

    // Small delay to show the snackbar, then refresh
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <Collapse
      in={show}
      sx={{
        ...(absolutePosition
          ? {
              position: "absolute",
              bottom: "50px",
              zIndex: 1000,
              width: "100%",
            }
          : {}),
      }}
    >
      <Alert
        severity="error"
        sx={{
          width: "100%",
          marginTop: "16px",
          marginBottom: "16px",
          borderRadius: "8px",
          "& .MuiAlert-message": {
            width: "100%",
          },
          "& .MuiAlert-action": {
            alignItems: "flex-start",
            paddingTop: "4px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AlertTitle>Version conflict detected</AlertTitle>
            <Typography variant="body2">
              This document has been updated since you last opened it and your
              changes may conflict with recent edits. Please copy any changes
              and refresh the page.
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="small"
            onClick={handleCopyAndRefresh}
            sx={{
              minWidth: "160px",
            }}
          >
            Copy + Refresh
          </Button>
        </Box>
      </Alert>
    </Collapse>
  );
};
